module.exports = "/_next/static/images/IlloUseCaseEnrichCustomerProfilesDefault-dcc470e609f32c8ec059b851f1091f94.png";